"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatsqr521MembersXL = exports.sqr521MembersXL = exports.Formatsqr521XL = exports.sqr521XL = exports.sqr521Title = void 0;
const Maybe_1 = require("../../lib/Maybe");
const Util_1 = require("../../lib/Util");
const ramda_1 = require("ramda");
const getHFZExpire = (reqs) => ramda_1.pipe(Util_1.get('HFZRecord'), Maybe_1.Maybe.filter(({ IsPassed }) => IsPassed || reqs.CurrentCadetAchv.CadetAchvID < 4), Maybe_1.Maybe.map(({ DateTaken, IsPassed }) => [DateTaken.substr(0, 10), IsPassed]), Maybe_1.Maybe.map(([s, f]) => [+new Date(s) + 182 * 24 * 60 * 60 * 1000, f]), Maybe_1.Maybe.map(([s, f]) => new Date(s).toLocaleDateString('en-US') + (!f ? ' F' : '')), Maybe_1.Maybe.orSome(''))(reqs);
const poweredFlights = [6, 7, 8, 9, 10];
exports.sqr521Title = 'Event Manager Cadet Status Report SQR 52-1';
const sqr521XL = () => {
    let row = [exports.sqr521Title];
    const retVal = [];
    retVal.push(row);
    retVal.push(['This document was generated on: ', '', '', Date.now()]);
    retVal.push([]);
    retVal.push([]);
    row = ['Comments'];
    retVal.push(row);
    retVal.push([]);
    return retVal;
};
exports.sqr521XL = sqr521XL;
const Formatsqr521XL = (sheet) => {
    const dateFormat = 'mm/dd/yyyy hh:mm';
    const dateWidth = dateFormat.length;
    sheet['!merges'] = [
        { s: { c: 0, r: 0 }, e: { c: 4, r: 0 } },
        { s: { c: 0, r: 1 }, e: { c: 2, r: 1 } },
        { s: { c: 1, r: 7 }, e: { c: 4, r: 7 } },
    ];
    sheet.D2.t = 'd';
    sheet.D2.z = dateFormat;
    sheet['!cols'] = [
        { width: 12 },
        { width: 12 },
        { wch: dateWidth },
        { wch: dateWidth },
        { width: 25 },
    ];
    sheet['!rows'] = [{ hpx: 19 }, { hpx: 17 }, {}, {}, {}];
    return sheet;
};
exports.Formatsqr521XL = Formatsqr521XL;
function formatPhoneNumber(phone) {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
        return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
    return phone;
}
;
const sqr521MembersXL = (nhqmembers) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let widths = [];
    let row = [
        'Sort',
        'Current Grade',
        'GradeOrder',
        'Full Name',
        'CAPID',
        'Bday',
        'Flight',
        'Joined',
        'Oride 1',
        'Oride 2',
        'Oride 3',
        'Oride 4',
        'Oride 5',
        'Cellphone',
        'Email',
        'Parent Phone',
        'Parent Email',
    ];
    const retVal = [];
    widths = [...row.map(item => item.toString().length)];
    retVal.push(row);
    const sortByMemberName = (a, b) => {
        const aMember = 'member' in a ? a.member : a;
        const bMember = 'member' in b ? b.member : b;
        return `${aMember.nameLast}, ${aMember.nameFirst}`.localeCompare(`${bMember.nameLast}, ${bMember.nameFirst}`);
    };
    const phase1Cadets = nhqmembers;
    nhqmembers[0].member.flight;
    const phase1CadetsDoc = [
        ...phase1Cadets,
    ]
        .sort(sortByMemberName)
        .map((mem) => ({
        requirements: 'requirements' in mem ? mem.requirements : null,
        member: 'member' in mem ? mem.member : mem,
    }));
    for (const loopmember of phase1CadetsDoc) {
        console.log(loopmember.requirements !== null
            ? getHFZExpire(loopmember.requirements)
            : 'reqs = null', loopmember.requirements);
        let flightCount = 0;
        const poweredFlightDates = ['', '', '', '', ''];
        if ((_a = loopmember.requirements) === null || _a === void 0 ? void 0 : _a.oflights) {
            loopmember.requirements.oflights.forEach(ride => {
                const idx = poweredFlights.indexOf(ride.Syllabus);
                if (idx !== -1) {
                    poweredFlightDates[idx] = ride.FltDate
                        ? new Date(ride.FltDate).toLocaleDateString('en-US')
                        : '';
                    flightCount += 1;
                }
            });
        }
        const birthDate = new Date(loopmember.member.dateOfBirth).getTime();
        const olderThan = new Date().setDate(new Date().getDate() - (365.25 * 18));
        row = [
            birthDate < olderThan ? "A" : flightCount === 5 ? "C" : loopmember.member.flight === "XRay" ? "X" : "",
            loopmember.member.memberRank,
            ((_b = loopmember.requirements) === null || _b === void 0 ? void 0 : _b.CurrentCadetAchv.CadetAchvID.toString())
                ? (_c = loopmember.requirements) === null || _c === void 0 ? void 0 : _c.CurrentCadetAchv.CadetAchvID.toString()
                : '',
            `${loopmember.member.memberRank} ${loopmember.member.nameLast}, ${loopmember.member.nameFirst}`,
            loopmember.member.id.toString(),
            { v: loopmember.member.dateOfBirth
                    ? new Date(birthDate).toLocaleDateString('en-US')
                    : '' },
            loopmember.member.flight !== null
                ? loopmember.member.flight
                : '',
            { v: loopmember.member.joined
                    ? new Date(loopmember.member.joined).toLocaleDateString('en-US')
                    : '', t: "s", s: {} },
            (_d = poweredFlightDates[0]) !== null && _d !== void 0 ? _d : '',
            (_e = poweredFlightDates[1]) !== null && _e !== void 0 ? _e : '',
            (_f = poweredFlightDates[2]) !== null && _f !== void 0 ? _f : '',
            (_g = poweredFlightDates[3]) !== null && _g !== void 0 ? _g : '',
            (_h = poweredFlightDates[4]) !== null && _h !== void 0 ? _h : '',
            loopmember.member.contact.CELLPHONE.PRIMARY
                ? formatPhoneNumber(loopmember.member.contact.CELLPHONE.PRIMARY)
                : '',
            (_j = loopmember.member.contact.EMAIL.PRIMARY) !== null && _j !== void 0 ? _j : '',
            loopmember.member.contact.CADETPARENTPHONE.PRIMARY
                ? formatPhoneNumber(loopmember.member.contact.CADETPARENTPHONE.PRIMARY)
                : '',
            (_k = loopmember.member.contact.CADETPARENTEMAIL.PRIMARY) !== null && _k !== void 0 ? _k : '',
        ];
        retVal.push(row);
    }
    return [retVal, widths.map(width => width + 3)];
};
exports.sqr521MembersXL = sqr521MembersXL;
const Formatsqr521MembersXL = (sheet, columnMaxWidths, numRows) => {
    const dateFormat = 'yyyy-mm-dd';
    const dateWidth = dateFormat.length + 1;
    const rowHeight = 22;
    sheet['!rows'] = [{ hpt: rowHeight }];
    sheet['!cols'] = columnMaxWidths.map(wch => ({ wch }));
    sheet['!cols'] = [
        { width: 8 },
        { width: 10 },
        { width: 8 },
        { width: 32 },
        { width: 8 },
        { wch: dateWidth },
        { width: 8 },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { width: 18 },
        { width: 40 },
        { width: 18 },
        { width: 40 },
    ];
    return sheet;
};
exports.Formatsqr521MembersXL = Formatsqr521MembersXL;
//# sourceMappingURL=sqr521.js.map